import bigInt from "big-integer";
export function prefixImgPath(imagePath) {
  if (imagePath.toLocaleLowerCase().indexOf("/uploads") === 0) {
    // console.log("Prefixing Image!");
    imagePath = `https://www.worldanvil.com${imagePath}`;
  }
  return imagePath;
}
export function disableEventPropagation(e) {
  if (e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    } else if (window.event) {
      window.event.cancelBubble = true;
    }
  }
}

export function buildCalendar(chronicleData) {
  if (
    Object.keys(chronicleData).length === 0 ||
    !chronicleData.units ||
    !chronicleData.months
  ) {
    return {};
  }
  function parseUnitValue(str) {
    // console.log(str)
    str = str.replace(/\,/gim, "");
    return str;
  }
  console.log("Form Data", chronicleData);
  const { units, months } = chronicleData;

  const hourDuration = bigInt(parseUnitValue(chronicleData.hourDuration))
    .times(parseUnitValue(chronicleData.minuteDuration))
    .toString();
  const dayDuration = bigInt(parseUnitValue(chronicleData.dayDuration))
    .times(hourDuration)
    .toString();
  const yearDuration = bigInt(parseUnitValue(chronicleData.yearDuration))
    .times(dayDuration)
    .toString();
  const decadeDuration = bigInt(parseUnitValue(chronicleData.decadeDuration))
    .times(yearDuration)
    .toString();
  const centuryDuration = bigInt(parseUnitValue(chronicleData.centuryDuration))
    .times(yearDuration)
    .toString();
  const milleniumDuration = bigInt(
    parseUnitValue(chronicleData.milleniumDuration)
  )
    .times(yearDuration)
    .toString();
  const myriadDuration = bigInt(parseUnitValue(chronicleData.myriadDuration))
    .times(yearDuration)
    .toString();
  const epochDuration = bigInt(parseUnitValue(chronicleData.epochDuration))
    .times(yearDuration)
    .toString();
  const aeonDuration = bigInt(parseUnitValue(chronicleData.aeonDuration))
    .times(yearDuration)
    .toString();

  const calendar = {
    months: [...months],
    time: {
      minute: {
        ...units.minute,
        duration: parseUnitValue(chronicleData.minuteDuration),
      },
      hour: {
        ...units.hour,
        duration: hourDuration,
      },
      day: {
        ...units.day,
        duration: dayDuration,
      },
      year: {
        ...units.year,
        duration: yearDuration,
      },
      decade: {
        ...units.decade,
        duration: decadeDuration,
      },
      century: {
        ...units.century,
        duration: centuryDuration,
      },
      millenium: {
        ...units.millenium,
        duration: milleniumDuration,
      },
      myriad: {
        ...units.myriad,
        duration: myriadDuration,
      },
      epoch: {
        ...units.epoch,
        duration: epochDuration,
      },
      aeon: {
        ...units.aeon,
        duration: aeonDuration,
      },
    },
  };

  // const unitKeys = Object.keys(units);
  // for (let k = 0; k < unitKeys.length; k++) {
  //   const key = unitKeys[k];
  //   const unitConfig = units[key];

  // }

  return calendar;
}

//Not optimized! This can be heavy with large objects!!
export function cloneObject(obj) {
  return { ...JSON.parse(JSON.stringify(obj)) };
}

export function formatClassName(input) {
  let str = input
    .slice()
    .replace(/\s/gim, "-")
    .replace(/[\[\]\(\)\{\}\.\~\`\*\+\^\%\$\#\@\!\=\\\/\,\<\>\?\'\"]/gim, "")
    .replace(/script|container|wrapper/gim, "REDACTED");

  if (/^[0-9]/gim.test(str)) {
    str = str.slice(1);
  }

  const className =
    str.length > 0 ? str[0].toLocaleLowerCase() + str.slice(1) : "";
  return className;
}
